export default __webpack_public_path__ + "static/media/app-ftz-02.9a89ed9c.png";